class StickyAddToCart extends HTMLElement {
	constructor() {
		super();
		this.anchor = document.getElementById('product-add-to-cart') || this.closest('.productView');
        this.mark = document.querySelector('footer');
        this.inner = this.querySelector('.sticky-inner');
		this.toogle = this.querySelector('[data-toogle-content-sticky]');
        this.toogle?.addEventListener('click', this.toggleEvent.bind(this));
	}

	connectedCallback(){
		this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    if(entry.boundingClientRect.top < 0) {
                        requestAnimationFrame(this.hide.bind(this));
                    }

                    entry.target.src = entry.target.dataset.src;
                    observer.unobserve(entry.target);
                } else {
                    if (this.anchor && this.check(this.anchor, 100)) {
                        requestAnimationFrame(this.show.bind(this));

                        // Sits flush against the bottom of the viewport by
                        // default (see CSS); only needs to lift above a
                        // mobile bottom toolbar when one is present, on any
                        // screen size that toolbar happens to be visible on.
                        const toolbar = document.querySelector('#Toolbar-halo-toolbar-mobile');

                        if (toolbar && toolbar.offsetHeight > 0) {
                            this.style.bottom = `${toolbar.offsetHeight}px`;
                        } else {
                            this.style.bottom = 0;
                        }
                    } else{
                        requestAnimationFrame(this.hide.bind(this));
                    }
                }
            });
        }, {
            threshold: [0, 1]
        });

        observer.observe(this.mark);
    }

    check(element, threshold) {
        let rect = element.getBoundingClientRect().y;
        threshold = threshold ? threshold : 0;

        return rect + threshold < 0
    }

    hide() {
    	this.classList.remove('show-sticky', 'full-sticky', 'animate');

        if (this.inner && this.inner.style.maxHeight) this.inner.style.maxHeight = null;
    }

    show() {
        this.classList.add('show-sticky', 'animate');
    }

    toggleEvent(event){
    	event.preventDefault();
        event.stopPropagation();

        if (!this.inner) return;

        if (this.inner.style.maxHeight){
            this.inner.style.maxHeight = null;
        } else {
            this.inner.style.maxHeight = `${this.inner.scrollHeight}px`;
        }

    	this.classList.toggle('full-sticky');
        this.toogle?.setAttribute('aria-expanded', this.classList.contains('full-sticky') ? 'true' : 'false');
    }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);